module.exports = __webpack_public_path__ + "static/img/shopLogo.00063a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/shopLogo.png
// module id = GxCk
// module chunks = 2